import React from 'react';
import PropTypes from 'prop-types';
import './EmailFail.less';

const EmailFail = ({
    labels: {heading, subheading, buttonText, reportLink},
    handleTryAgain,
    height,
    helpUrl,
    retriesCount,
    maxRetriesToEnableReporting,
}) => (
    <div className="EmailFail" style={{height: `${height}px`}}>
        <h2 className="EmailFail__heading">{heading}</h2>
        <p className="EmailFail__subheading">{subheading}</p>
        <div className="EmailFail__actions">
            <button
                className="EmailFail__submit btn btn-md btn-primary"
                onClick={handleTryAgain}
            >
                {buttonText}
            </button>
            {retriesCount >= maxRetriesToEnableReporting && (
                <a className="EmailFail__link" href={helpUrl} target="_blank">
                    {reportLink}
                </a>
            )}
        </div>
    </div>
);

EmailFail.propTypes = {
    handleTryAgain: PropTypes.func,
    height: PropTypes.number,
    helpUrl: PropTypes.string,
    labels: PropTypes.shape({
        heading: PropTypes.string,
        subheading: PropTypes.string,
        buttonText: PropTypes.string,
        reportLink: PropTypes.string,
    }),
    maxRetriesBeforeEnableReporting: PropTypes.number,
    retriesCount: PropTypes.number,
};

export default EmailFail;
